module.exports = __webpack_public_path__ + "static/media/coloqueDrone.49660d92.png";